import { LocationNameInput } from "libs/types/API";

export const formatAddress = (location: LocationNameInput, multiLine?: boolean) => {
  const seperator = multiLine ? `\n` : `, `;
  return [location.address, location.city, location.postcode].filter((x) => x).join(seperator);
};
